/// This file was generated DO NOT MODIFY
/// Source: BudgetPercentDenominator.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum BudgetPercentDenominatorEnum {
  Parent = 'Parent', //0
  Project = 'Project', //1
  
}
